module.exports = __webpack_public_path__ + "img/傲慢.0d8c2519.png";